import { createReducer } from "../../../generic/redux/createReducer";
import { pairActionTypeToReducer } from "../../../generic/redux/TypedRedux";

import type { ChangeTab, ChangeTimeout, QueryChanged, QueryError, QueryResultChanged } from "./AnalyticsActions";
import {
	CHANGE_TAB,
	CHANGE_TIMEOUT,
	CLEAR_QUERY,
	EXECUTE_QUERY,
	QUERY_CHANGED,
	QUERY_ERROR,
	QUERY_RESULT_CHANGED,
} from "./AnalyticsActionTypes";
import { AnalyticsQuery, type AnalyticsQueryWithResult } from "./AnalyticsQuery";
import { type AnalyticsState, initialAnalyticsState } from "./AnalyticsState";

function sliceHistory(state: AnalyticsState): Array<AnalyticsQueryWithResult> {
	return state.history.slice(0, 9);
}

function changeQueryReducer(state: AnalyticsState, action: QueryChanged): AnalyticsState {
	return {
		...state,
		query: new AnalyticsQuery(action.query),
	};
}

function storeErrorReducer(state: AnalyticsState, error: QueryError): AnalyticsState {
	return {
		...state,
		isLoading: false,
		history: [state.query.withResult(error), ...sliceHistory(state)],
	};
}

function storeQueryResultReducer(state: AnalyticsState, action: QueryResultChanged): AnalyticsState {
	return {
		...state,
		isLoading: false,
		history: [
			state.query.withResult({
				data: action.data,
				type: action.dataType,
			}),
		].concat(sliceHistory(state)),
	};
}

function clearQueryReducer(state: AnalyticsState): AnalyticsState {
	return {
		...state,
		query: new AnalyticsQuery(),
	};
}

function changeTimeoutReducer(state: AnalyticsState, { timeout }: ChangeTimeout): AnalyticsState {
	return {
		...state,
		config: {
			timeout,
		},
	};
}

function changeTabReducer(state: AnalyticsState, { tabName }: ChangeTab): AnalyticsState {
	return {
		...state,
		activeTab: tabName,
	};
}

function executeQueryReducer(state: AnalyticsState): AnalyticsState {
	return {
		...state,
		isLoading: true,
		activeTab: "result",
	};
}

export const AnalyticsReducer = createReducer<AnalyticsState>(initialAnalyticsState, {
	...pairActionTypeToReducer(EXECUTE_QUERY, executeQueryReducer),
	...pairActionTypeToReducer(QUERY_ERROR, storeErrorReducer),
	...pairActionTypeToReducer(QUERY_RESULT_CHANGED, storeQueryResultReducer),
	...pairActionTypeToReducer(QUERY_CHANGED, changeQueryReducer),
	...pairActionTypeToReducer(CLEAR_QUERY, clearQueryReducer),
	...pairActionTypeToReducer(CHANGE_TIMEOUT, changeTimeoutReducer),
	...pairActionTypeToReducer(CHANGE_TAB, changeTabReducer),
});
